import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';
import * as categoryActions from '../../../../Containers/Partners/Components/ProductsSelector/service/categories/actions';
import { ALL } from '../../../../Containers/Partners/Components/ProductsSelector/Components/ProductsSelectorModal/utils';
import {
	parseCategoryByMenu,
	getCategorySelected,
	getCategoryCounts,
	PSEUDO,
} from './selector';

// Colonne gauche : navigation par catégorie du menu courant + filtres transverses
// (produits des exports, non configurés). Réutilise le slice productsSelector.
class CategoryList extends React.Component {
	onSelect = id => {
		if (id !== this.props.selected) {
			this.props.select(id);
		}
	};

	renderItem = (id, name, primary) => {
		const count = this.props.counts[id];
		return (
			<ListItem
				key={id}
				button
				selected={this.props.selected === id}
				onClick={() => this.onSelect(id)}
				className="binding-category-item">
				<ListItemText
					primary={
						<div className="binding-category-line">
							<span className="binding-category-name">{name}</span>
							{count != null ? (
								<span className="binding-category-count">{count}</span>
							) : null}
						</div>
					}
					primaryTypographyProps={{
						style: {
							fontFamily:
								this.props.selected === id ? 'FuturaHeavy' : 'FuturaBook',
							fontSize: primary ? 18 : 15,
						},
					}}
				/>
			</ListItem>
		);
	};

	render() {
		const { categories } = this.props;

		return (
			<React.Fragment>
				<h2>{I18n.t('settings.binding.categories_title')}</h2>
				<List className="binding-category-list">
					{/* filtres transverses */}
					{this.renderItem(
						PSEUDO.EXPORTS,
						I18n.t('settings.binding.export_products'),
						true
					)}
					{/* {this.renderItem(
						PSEUDO.UNCONFIGURED,
						I18n.t('settings.binding.unconfigured_products'),
						true
					)} */}
					<Divider className="binding-category-divider" />
					{this.renderItem(
						ALL,
						I18n.t('settings.binding.all_categories'),
						true
					)}
					{this.renderItem(0, I18n.t('settings.binding.no_category'), true)}
					{Object.values(categories).map(category =>
						this.renderItem(category.id, category.name, false)
					)}
				</List>
			</React.Fragment>
		);
	}
}

CategoryList.propTypes = {
	categories: PropTypes.object.isRequired,
	selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	counts: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
	categories: parseCategoryByMenu(state),
	selected: getCategorySelected(state),
	counts: getCategoryCounts(state),
});

const mapDispatchToProps = dispatch => ({
	select: bindActionCreators(categoryActions.select, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList);
